module.exports = __webpack_public_path__ + "img/twitter-greyscale.5dfb1330.svg";